import { TableLazyLoadEvent } from '@openng/optimus-ui/table';
import { BaseModel } from '../../model/common/base-model';

export class BaseTableService<T extends BaseModel> {
  private selected: T | null = null;
  private lastQuery: any;
  private lastFilters: any;
  private lastRowSetting: number = 0;
  private lastTotalRecords: number = -1;
  private lastPageIndex: number = 0;
  private lastSortField: string = '';
  private lastSortDirection: number = 1;

  private lastLazyLoad: TableLazyLoadEvent | null = null;

  constructor() {}

  getLastLazyLoad() {
    return this.lastLazyLoad;
  }

  setLastLazyLoad(lastLazy: TableLazyLoadEvent | null) {
    if (lastLazy) {
      this.lastLazyLoad = { ...lastLazy };
    } else {
      this.lastLazyLoad = null;
    }
  }

  getSelected() {
    return this.selected;
  }

  setSelected(item: T | null) {
    this.selected = item;
  }

  setLastQuery(query: any) {
    this.lastQuery = query;
  }

  getLastQuery() {
    return this.lastQuery;
  }

  setLastFilters(filters: any) {
    this.lastFilters = filters;
  }

  getLastFilters(): any {
    if (!this.lastFilters) {
      return {};
    }

    return this.lastFilters;
  }

  clearResults() {
    this.selected = null;
    this.lastQuery = {};
    this.lastFilters = {};
    this.lastRowSetting = 0;
    this.lastTotalRecords = 0;
    this.lastPageIndex = 0;
    this.lastSortField = '';
    this.lastSortDirection = 0;
  }

  setLastRowSetting(setting: number) {
    this.lastRowSetting = setting;
  }

  getLastRowSetting() {
    if (!this.lastRowSetting) {
      this.lastRowSetting = 50;
    }
    return this.lastRowSetting;
  }

  setLastTotalRecords(records: number) {
    this.lastTotalRecords = records;
  }

  getLastTotalRecords() {
    return this.lastTotalRecords;
  }

  setLastPageIndex(index: number) {
    this.lastPageIndex = index;
  }

  getLastPageIndex() {
    return this.lastPageIndex;
  }

  setLastSortField(field: string) {
    this.lastSortField = field;
  }

  getLastSortField() {
    return this.lastSortField;
  }

  setLastSortDirection(dir: number) {
    this.lastSortDirection = dir;
  }

  getLastSortDirection() {
    return this.lastSortDirection;
  }
}
